import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'trattoria_tavolare';
// export const customerGroup = 'default_in_preparation';
// export const customerGroup = 'bjorns_backyard';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyAaO3DQLFGQAhElalC0xDlF8e0z6GR3uA8',
		authDomain: 'trattoria-f62bc.firebaseapp.com',
		projectId: 'trattoria-f62bc',
		storageBucket: 'trattoria-f62bc.firebasestorage.app',
		messagingSenderId: '284445045480',
		appId: '1:284445045480:web:77e37015ab0553c11c4f5d',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '3000032616',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
